import { DataContent } from "components/ui/DataContent";

const PageHeaderDataContent = DataContent;

export { PageHeaderDataContent };
